import { loadTranslations } from 'react-redux-i18n'
import { store } from '../../../../../app/store'

store.dispatch(
  loadTranslations({
    en: {
      ...store.getState().i18n.translations.en,
      screening: {
        SCREENING: 'Screening',
        CORPORATE: 'Corporate',
        BANK: 'Bank',
        SECURITIES: 'Securities',
        INSURANCE: 'Insurance',
        BASIC_INFORMATION: 'Basic Information',
        INDUSTRY: 'Industry',
        FINANCIALS: 'Financials',
        BALANCE_SHEET: 'Balance Sheet',
        INCOME_STATEMENT: 'Income Statement',
        CASHFLOW_STATEMENT: 'Cashflow Statement',
        RATIOS: 'Ratios',
        CURRENCY: 'Currency',
        LEVEL: 'Level',
        FROM: 'From',
        TO: 'To',
        HAS_PARENT_COMPANY: 'Has parent',
        HAS_NO_PARENT_COMPANY: 'Has no parent',
        INDEPENDENT_COMPANIES: 'Independent companies',
        NON_INDEPENDENT_COMPANIES: 'Non-independent companies',
        INDEPENDENT_COMPANY_TOOLTIP:
          'A company is considered independent when:<br>- It is not owned >25% by another company<br>- It does not own >25% of any company<br>- It has no subsidiaries<br>- Its legal representative does not represent any other company',
        PROVINCE: 'Province',
        DISTRICT: 'Ward',
        ASC: 'Ascending',
        DESC: 'Descending',
        CLOSE: 'Close',
        WARNING: 'Warning',
        NO_DATA_SEARCH: 'No items match your search.',
        APPLY: 'Apply',
        CANCEL: 'Cancel',
        SAVE: 'Save',
        ENTER_CRITERIA_NAME: 'Enter criteria name',
        SAVE_CRITERIA_AS: 'Save this criteria as',
        SAVE_CHANGE_TO: 'Save your changes to "%{name}"',
        SAVE_AS: 'Save as',
        CRITERIA_NAME_REQUIRED_MESS: 'Name of criteria is required',
        DELETE: 'Delete',
        YES: 'Yes',
        NO: 'No',
        CONFIRMATION: 'Confirmation',
        OPEN_RECENT_SAVED_MESS:
          'Your criteria have been saved.<br>Do you want to open recently saved criteria?',
        DONT_SAVE: "Don't Save",
        SAVE_CRITERIA_BEFORE_LEAVE_MESS:
          'Do you want to save this criteria before leaving?',
        FROM_DATE_PLACEHOLDER: 'From: dd-mmm-yyyy',
        TO_DATE_PLACEHOLDER: 'To: dd-mmm-yyyy',

        // Select screen
        ALL_SAVED_CRITERIA: 'All Saved Criteria',
        NEXT: 'Next',
        SEARCH_CRITERIA_NAMWE: 'Search criteria name',
        SEARCH_INDUSTRY: 'Search industry name or code',
        TOTAL_RESULT: 'Total Results (%{count} result%{suffix})',
        EMPTY_CRITERIA_MESS: 'Select criteria from the left panel',
        SAVE_CRITERIA: 'Save Criteria',
        CLEAR_ALL: 'Clear All',
        MAX_CONDITION_MESS: 'The number of conditions is no more than %{max}!',
        SELECT_ITEMS: 'Select Items',
        NUMBER_ITEM_SELECTED: '%{count} item%{suffix} selected',
        REQUIRED_MESS: 'Please fill in or delete this field!',
        MAX_INDICATOR_MESS:
          'You can only add up to %{max} criteria.<br> Please try again!',

        //Export screen
        EXPORT_FILE_SETTING: 'Export File Settings',
        BACK_TO_SCREENING: 'Back to Screening',
        BUY_NOW: 'Buy Now',
        SELECTED_CRITERIA: 'Selected Criteria',
        ADD_INFO_TO_VIEW: 'Add Information to View',
        TOTAL_INFORMATION: 'Total Information',
        ADD_MAX_INFORMATION: '(Add up to %{max} Information)',
        SEARCH_INFORMATION: 'Search information',
        DEFAULT_INFO:
          'Company Name, Tax Code, Status, Address, Phone Number, Main VSIC, Company Type, Listing Status',
        DEFAULT_INFO_TOOLTIP: 'Default information: cannot be moved or removed',
        VIEW_COUNT: 'View',
        SORT_BY: 'Sort by',
        COUNT_RESULT: 'result%{suffix}',
        NUMBER_OF_COMPANY_REQUIRED: 'Number of companies to view is required',
        PAYMENT_INFORMATION: 'Payment Information',
        PRICE: 'Price',
        UNIT_PRICE: 'Unit Price',
        TRADE_DISCOUNT: 'Trade Discount on Order',
        TOTAL_PAYMENT: 'Total Payment',
        VAT_INCLUDED: '(VAT included)',
        MAX_ADDITIONAL_INFO_MESS:
          'The number of information is no more than %{max}.',
        SELECT_OR_ENTER_CODE: 'Select or enter code',
        CONFIRM_EXECUTE_TRANSACTION:
          'Do you want to execute the screening transaction?',
        CHOOSE_LANGUAGE: 'Choose language for Screening file',

        //Saved Criteria screen
        SEARCH_SAVED_CRITERIA: 'Enter saved criteria name',
        DATE_MODIFIED: 'Date Modified',
        CRITERIA_NAME: 'Saved Criteria',
        CREATE_AT: 'Date Created',
        UPDATE_AT: 'Date Modified',
        NO_SAVED_CRITERIA: 'No criteria have been saved.',
        NO_SEARCH_CRITERIA: 'No items match your search.',
        DELETE_CRITERIA: 'Delete',
        DELETE_CRITERIA_MESS:
          'Are you sure you want to delete <b>"%{name}"</b>?',
        APPLY_CRITERIA: 'Apply criteria',
        APPLY_CRITERIA_MESS:
          'Are you sure to apply <b>"%{name}"</b>?<br>If you click Apply your selected criteria will be replaced.',
        CHOOSE_FILE: 'Choose file',
        NO_CHOOSE_FILE: 'No files selected',
        UP_LOAD: 'Upload',
        DOWNLOAD_TEMPLATE: 'Download template',
        VALIDATE_FORMAT_FILE: '! Invalid file format',
      },
    },
    vi: {
      ...store.getState().i18n.translations.vi,
      screening: {
        SCREENING: 'Sàng lọc tự động',
        CORPORATE: 'Doanh Nghiệp',
        BANK: 'Ngân Hàng',
        SECURITIES: 'Chứng Khoán',
        INSURANCE: 'Bảo Hiểm',
        BASIC_INFORMATION: 'Thông tin cơ bản',
        INDUSTRY: 'Ngành',
        FINANCIALS: 'Thông tin tài chính',
        BALANCE_SHEET: 'Bảng Cân Đối',
        INCOME_STATEMENT: 'Kết Quả Kinh Doanh',
        CASHFLOW_STATEMENT: 'Lưu Chuyển Tiền Tệ',
        RATIOS: 'Chỉ Số Tài Chính',
        CURRENCY: 'Tiền tệ',
        LEVEL: 'Cấp',
        FROM: 'Từ',
        TO: 'Đến',
        HAS_PARENT_COMPANY: 'Có công ty mẹ',
        HAS_NO_PARENT_COMPANY: 'Không có công ty mẹ',
        INDEPENDENT_COMPANIES: 'Công ty độc lập',
        NON_INDEPENDENT_COMPANIES: 'Công ty không độc lập',
        INDEPENDENT_COMPANY_TOOLTIP:
          'Doanh nghiệp độc lập được xác định theo:<br>- Không bị doanh nghiệp khác sở hữu >25%<br>- Không sở hữu >25% bất kỳ doanh nghiệp nào<br>- Không có công ty con<br>- Người đại diện pháp luật không đồng thời đại diện pháp luật doanh nghiệp khác',
        PROVINCE: 'Tỉnh',
        DISTRICT: 'Phường / Xã',
        ASC: 'Tăng dần',
        DESC: 'Giảm dần',
        CLOSE: 'Đóng',
        WARNING: 'Chú ý',
        NO_DATA_SEARCH: 'Không có kết quả phù hợp.',
        APPLY: 'Áp Dụng',
        CANCEL: 'Hủy',
        SAVE: 'Lưu',
        ENTER_CRITERIA_NAME: 'Nhập tên bộ tiêu chí',
        SAVE_CRITERIA_AS: 'Lưu bộ tiêu chí của bạn thành',
        SAVE_CHANGE_TO: 'Lưu thay đổi vào "%{name}"',
        SAVE_AS: 'Lưu thành',
        CRITERIA_NAME_REQUIRED_MESS: 'Vui lòng điền tên bộ tiêu chí',
        DELETE: 'Xóa',
        YES: 'Có',
        NO: 'Không',
        CONFIRMATION: 'Xác nhận',
        OPEN_RECENT_SAVED_MESS:
          'Bộ tiêu chí đã được lưu.<br>Bạn có muốn xem bộ tiêu chí vừa lưu?',
        DONT_SAVE: 'Không Lưu',
        SAVE_CRITERIA_BEFORE_LEAVE_MESS:
          'Bạn có muốn lưu bộ tiêu chí lọc hiện tại không?',
        FROM_DATE_PLACEHOLDER: 'Từ: dd/mm/yyyy',
        TO_DATE_PLACEHOLDER: 'Đến: dd/mm/yyyy',

        // Select screen
        ALL_SAVED_CRITERIA: 'Bộ Tiêu Chí Đã Lưu',
        NEXT: 'Tiếp Theo',
        SEARCH_CRITERIA_NAMWE: 'Tìm kiếm tiêu chí lọc',
        SEARCH_INDUSTRY: 'Tìm kiếm ngành theo tên hoặc mã ngành',
        TOTAL_RESULT: 'Số lượng kết quả (%{count} công ty)',
        EMPTY_CRITERIA_MESS: 'Lựa chọn tiêu chí từ danh sách bên cạnh',
        SAVE_CRITERIA: 'Lưu bộ tiêu chí',
        CLEAR_ALL: 'Xóa tất cả',
        MAX_CONDITION_MESS: 'Số lượng điều kiện lọc tối đa là %{max}!',
        SELECT_ITEMS: 'Chọn mục',
        NUMBER_ITEM_SELECTED: 'Đã chọn %{count} mục',
        REQUIRED_MESS: 'Vui lòng nhập điều kiện hoặc xóa trường này!',
        MAX_INDICATOR_MESS:
          'Số lượng tiêu chí được phép thêm tối đa là %{max}.<br> Vui lòng thử lại!',

        //Export screen
        EXPORT_FILE_SETTING: 'Tùy Chỉnh Tập Kết Quả',
        BACK_TO_SCREENING: 'Quay lại màn Sàng lọc tự động',
        BUY_NOW: 'Mua Ngay',
        SELECTED_CRITERIA: 'Tiêu Chí Đã Chọn',
        ADD_INFO_TO_VIEW: 'Xem thêm thông tin kết quả',
        TOTAL_INFORMATION: 'Trường Thông Tin Kết Quả',
        ADD_MAX_INFORMATION: '(Có thể thêm %{max} thông tin tài chính khác)',
        SEARCH_INFORMATION: 'Tìm kiếm trường thông tin',
        DEFAULT_INFO:
          'Tên Công Ty, Mã Số Thuế, Trạng Thái Hoạt Động, Địa Chỉ, Số Điện Thoại, Ngành VSIC Đăng Ký, Loại Công Ty, Trạng Thái Niêm Yết',
        DEFAULT_INFO_TOOLTIP:
          'Thông tin mặc định: không thay đổi vị trí hoặc xóa bỏ',
        VIEW_COUNT: 'Chọn',
        SORT_BY: 'Sắp xếp theo',
        COUNT_RESULT: 'công ty',
        NUMBER_OF_COMPANY_REQUIRED:
          'Vui lòng điền số lượng công ty bạn muốn xem kết quả',
        PAYMENT_INFORMATION: 'Thông Tin Thanh Toán',
        PRICE: 'Giá',
        UNIT_PRICE: 'Đơn Giá',
        TRADE_DISCOUNT: 'Chiết Khấu Thương Mại cho Đơn Hàng',
        TOTAL_PAYMENT: 'Thanh toán',
        VAT_INCLUDED: '(đã bao gồm VAT)',
        MAX_ADDITIONAL_INFO_MESS: 'Số lượng thông tin tối đa là %{max}.',
        SELECT_OR_ENTER_CODE: 'Chọn hoặc nhập mã',
        CONFIRM_EXECUTE_TRANSACTION:
          'Bạn có muốn thực hiện giao dịch Sàng lọc tự động không?',
        CHOOSE_LANGUAGE: 'Chọn ngôn ngữ cho kết quả sàng lọc',

        //Saved Criteria screen
        SEARCH_SAVED_CRITERIA: 'Tìm kiếm bộ tiêu chí',
        DATE_MODIFIED: 'Ngày Cập Nhật',
        CRITERIA_NAME: 'Bộ Tiêu Chí',
        CREATE_AT: 'Ngày Tạo',
        UPDATE_AT: 'Ngày Cập Nhật',
        NO_SAVED_CRITERIA: 'Chưa tồn tại bộ tiêu chí lọc được lưu',
        NO_SEARCH_CRITERIA: 'Không có kết quả phù hợp.',
        DELETE_CRITERIA: 'Xóa bộ tiêu chí',
        DELETE_CRITERIA_MESS: 'Bạn muốn xóa <b>"%{name}"</b>?',
        APPLY_CRITERIA: 'Áp dụng bộ tiêu chí',
        APPLY_CRITERIA_MESS:
          'Bạn muốn sử dụng bộ tiêu chí <b>"%{name}"</b>?<br>Nếu chọn Áp dụng các tiêu chí đã chọn sẽ được thay thế bởi bộ tiêu chí trên.',
        CHOOSE_FILE: 'Chọn file',
        NO_CHOOSE_FILE: 'Chưa có file tải lên',
        UP_LOAD: 'Tải lên',
        DOWNLOAD_TEMPLATE: 'Tải mẫu',
        VALIDATE_FORMAT_FILE: '! Định dạng tệp không hợp lệ',
      },
    },
  }),
)
